export default __webpack_public_path__ + "1a481fdacd68df03b956088326ad2001.svg";